import ActivityCard from "./components/ActivityCard";
import TimeOffCard from "./components/TimeOffCard";
import TeamOccupationCard from "./components/TeamOccupationCard";
import ProfitabilityCard from "./components/ProfitabilityCard";

const Overview = ({ user, filters, organisation, businessUnit }) => {
  return (
    <div className="p-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <ActivityCard user={user} filters={filters} organisation={organisation} businessUnit={businessUnit} />
      <TeamOccupationCard user={user} filters={filters} businessUnit={businessUnit} />
      <ProfitabilityCard user={user} filters={filters} organisation={organisation} businessUnit={businessUnit} />
      <TimeOffCard user={user} filters={filters} organisation={organisation} businessUnit={businessUnit} />
    </div>
  );
};

export default Overview;
